<div class="modal-header py-3 pl-4 pr-3">
  <h4 class="modal-title">{{title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body p-4">
  <div class="form-group mb-3">
    <p class="mb-0" [innerHTML]="description"></p>
  </div>
  <div class="form-group p-2">
    <div class="form-group mb-3">
      <a class="h6 mb-0" href="{{ lgpd.linkTermosUso }}" target="_blank">{{'Termos de Uso'|translate}}</a>
    </div>
    <div class="form-group mb-3">
      <a class="h6 mb-0" href="{{ lgpd.linkPoliticaPrivacidade }}" target="_blank">{{'Política de Privacidade'|translate}}</a>
    </div>
  </div>
  <div class="form-group mt-3 mb-0">
    <div class="mx-3 custom-checkbox">
      <input type="checkbox" class="custom-control-input" [(ngModel)]="aceitouTermos" id="aceitouTermosLgpd">
      <label class="mb-0 custom-control-label" for="aceitouTermosLgpd">
        {{ gerarTermoDeUsoIntegrador() }}
      </label>
    </div>
  </div>
</div>
<div class="modal-footer py-3 px-4">
  <button type="button" class="btn btn-primary btn-raised" (click)="confirmModel()" [disabled]="!aceitouTermos">{{'Aceitar e continuar'|translate}}</button>
  <button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.dismiss()">{{'Voltar'|translate}}</button>
</div>
